var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbnail1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 225,
    viewBox: "0 0 344 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 344,
    height: 225,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.97107,
    y: 18.8306,
    width: 59.8261,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 139.594,
    y: 18.8306,
    width: 59.8261,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 74.7826,
    y: 18.8306,
    width: 59.8261,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 204.406,
    y: 18.8306,
    width: 59.8261,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9.97107,
    y: 31.0181,
    width: 324.058,
    height: 1.875,
    fill: "#E0E0E0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 9.97107,
    y: 42.2681,
    width: 134.582,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 9.97107,
    y: 9.45557,
    width: 99.7101,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 9.97107,
    y: 63.9229,
    width: 21.9362,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 9.97107,
    y: 132.224,
    width: 21.9362,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 9.97107,
    y: 56.3306,
    width: 21.9362,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 9.97107,
    y: 71.5112,
    width: 21.9362,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 9.97107,
    y: 139.816,
    width: 21.9362,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 9.97107,
    y: 79.0991,
    width: 21.9362,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 9.97107,
    y: 147.404,
    width: 21.9362,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 9.97107,
    y: 86.6899,
    width: 21.9362,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 9.97107,
    y: 154.992,
    width: 21.9362,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 9.97107,
    y: 109.457,
    width: 21.9362,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 9.97107,
    y: 177.759,
    width: 21.9362,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 9.97107,
    y: 94.2778,
    width: 21.9362,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 9.97107,
    y: 162.584,
    width: 21.9362,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 9.97107,
    y: 117.049,
    width: 21.9362,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 9.97107,
    y: 185.347,
    width: 21.9362,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 9.97107,
    y: 200.53,
    width: 21.9362,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 9.97107,
    y: 101.866,
    width: 21.9362,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 9.97107,
    y: 170.172,
    width: 21.9362,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 9.97107,
    y: 124.637,
    width: 21.9362,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 9.97107,
    y: 192.938,
    width: 21.9362,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 9.97107,
    y: 208.118,
    width: 21.9362,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 123.641,
    y: 63.9229,
    width: 33.9015,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 123.641,
    y: 132.224,
    width: 33.9015,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 123.641,
    y: 56.3306,
    width: 33.9015,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 123.641,
    y: 71.5112,
    width: 33.9015,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 123.641,
    y: 139.816,
    width: 33.9015,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 123.641,
    y: 79.0991,
    width: 33.9015,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 123.641,
    y: 147.404,
    width: 33.9015,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 123.641,
    y: 86.6899,
    width: 33.9015,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 123.641,
    y: 154.992,
    width: 33.9015,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 123.641,
    y: 109.457,
    width: 33.9015,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 123.641,
    y: 177.759,
    width: 33.9015,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 123.641,
    y: 94.2778,
    width: 33.9015,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 123.641,
    y: 162.584,
    width: 33.9015,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 123.641,
    y: 117.049,
    width: 33.9015,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 123.641,
    y: 185.347,
    width: 33.9015,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 123.641,
    y: 200.53,
    width: 33.9015,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 123.641,
    y: 101.866,
    width: 33.9015,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 123.641,
    y: 170.172,
    width: 33.9015,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 123.641,
    y: 124.637,
    width: 33.9015,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 123.641,
    y: 192.938,
    width: 33.9015,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 123.641,
    y: 208.118,
    width: 33.9015,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 157.542,
    y: 63.9229,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 157.542,
    y: 132.224,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 157.542,
    y: 56.3306,
    width: 23.9304,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 157.542,
    y: 71.5112,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 157.542,
    y: 139.816,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 157.542,
    y: 79.0991,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 157.542,
    y: 147.404,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 157.542,
    y: 86.6899,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 157.542,
    y: 154.992,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 157.542,
    y: 109.457,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 157.542,
    y: 177.759,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 157.542,
    y: 94.2778,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 157.542,
    y: 162.584,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 157.542,
    y: 117.049,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 157.542,
    y: 185.347,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 157.542,
    y: 200.53,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 157.542,
    y: 101.866,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 157.542,
    y: 170.172,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 157.542,
    y: 124.637,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 157.542,
    y: 192.938,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 157.542,
    y: 208.118,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 181.472,
    y: 63.9229,
    width: 28.9159,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 181.472,
    y: 132.224,
    width: 28.9159,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 181.472,
    y: 56.3306,
    width: 28.9159,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 181.472,
    y: 71.5112,
    width: 28.9159,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 181.472,
    y: 139.816,
    width: 28.9159,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 181.472,
    y: 79.0991,
    width: 28.9159,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 181.472,
    y: 147.404,
    width: 28.9159,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 181.472,
    y: 86.6899,
    width: 28.9159,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 181.472,
    y: 154.992,
    width: 28.9159,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 181.472,
    y: 109.457,
    width: 28.9159,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 181.472,
    y: 177.759,
    width: 28.9159,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 181.472,
    y: 94.2778,
    width: 28.9159,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 181.472,
    y: 162.584,
    width: 28.9159,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 181.472,
    y: 117.049,
    width: 28.9159,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 181.472,
    y: 185.347,
    width: 28.9159,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 181.472,
    y: 200.53,
    width: 28.9159,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 181.472,
    y: 101.866,
    width: 28.9159,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 181.472,
    y: 170.172,
    width: 28.9159,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 181.472,
    y: 124.637,
    width: 28.9159,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 181.472,
    y: 192.938,
    width: 28.9159,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 181.472,
    y: 208.118,
    width: 28.9159,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 210.388,
    y: 63.9229,
    width: 99.7101,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 210.388,
    y: 132.224,
    width: 99.7101,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 210.388,
    y: 56.3306,
    width: 99.7101,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 210.388,
    y: 71.5112,
    width: 99.7101,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 210.388,
    y: 139.816,
    width: 99.7101,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 210.388,
    y: 79.0991,
    width: 99.7101,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 210.388,
    y: 147.404,
    width: 99.7101,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 210.388,
    y: 86.6899,
    width: 99.7101,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 210.388,
    y: 154.992,
    width: 99.7101,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 210.388,
    y: 109.457,
    width: 99.7101,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 210.388,
    y: 177.759,
    width: 99.7101,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 210.388,
    y: 94.2778,
    width: 99.7101,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 210.388,
    y: 162.584,
    width: 99.7101,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 210.388,
    y: 117.049,
    width: 99.7101,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 210.388,
    y: 185.347,
    width: 99.7101,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 210.388,
    y: 200.53,
    width: 99.7101,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 210.388,
    y: 101.866,
    width: 99.7101,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 210.388,
    y: 170.172,
    width: 99.7101,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 210.388,
    y: 124.637,
    width: 99.7101,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 210.388,
    y: 192.938,
    width: 99.7101,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 210.388,
    y: 208.118,
    width: 99.7101,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 310.099,
    y: 63.9229,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 310.099,
    y: 132.224,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 310.099,
    y: 56.3306,
    width: 23.9304,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 310.099,
    y: 71.5112,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 310.099,
    y: 139.816,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 310.099,
    y: 79.0991,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 310.099,
    y: 147.404,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 310.099,
    y: 86.6899,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 310.099,
    y: 154.992,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 310.099,
    y: 109.457,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 310.099,
    y: 177.759,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 310.099,
    y: 94.2778,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 310.099,
    y: 162.584,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 310.099,
    y: 117.049,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 310.099,
    y: 185.347,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 310.099,
    y: 200.53,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 310.099,
    y: 101.866,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 310.099,
    y: 170.172,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 310.099,
    y: 124.637,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 310.099,
    y: 192.938,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 310.099,
    y: 208.118,
    width: 23.9304,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9072,
    y: 63.9229,
    width: 91.7333,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9072,
    y: 132.224,
    width: 91.7333,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9072,
    y: 56.3306,
    width: 91.7333,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9072,
    y: 71.5112,
    width: 91.7333,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9072,
    y: 139.816,
    width: 91.7333,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9072,
    y: 79.0991,
    width: 91.7333,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9072,
    y: 147.404,
    width: 91.7333,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9072,
    y: 86.6899,
    width: 91.7333,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9072,
    y: 154.992,
    width: 91.7333,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9072,
    y: 109.457,
    width: 91.7333,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9072,
    y: 177.759,
    width: 91.7333,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9072,
    y: 94.2778,
    width: 91.7333,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9072,
    y: 162.584,
    width: 91.7333,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9072,
    y: 117.049,
    width: 91.7333,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9072,
    y: 185.347,
    width: 91.7333,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9072,
    y: 200.53,
    width: 91.7333,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9072,
    y: 101.866,
    width: 91.7333,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9072,
    y: 170.172,
    width: 91.7333,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9072,
    y: 124.637,
    width: 91.7333,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9072,
    y: 192.938,
    width: 91.7333,
    height: 7.58929,
    stroke: "#CCCCCC"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9072,
    y: 208.118,
    width: 91.7333,
    height: 7.58929,
    stroke: "#CCCCCC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail1);
export default __webpack_public_path__ + "static/media/thumbnail-1.20182f102296cfb00fc9e7ed373cc094.svg";
export { ForwardRef as ReactComponent };